define('home/views/TopicTagCollectionView',[
    'backbone-marionette',

    'home/views/TopicTagView',
], function (
    Marionette,

    TopicTagView
) {
    'use strict';

    var TopicTagCollectionView = Marionette.CollectionView.extend({
        className: 'topic-group__wrapper',

        itemView: TopicTagView,
        itemViewOptions: function () {
            return {
                baseTopicRoute: this.baseTopicRoute,
            };
        },

        initialize: function (options) {
            options = options || {};

            this.baseTopicRoute = options.baseTopicRoute;

            if (!this.baseTopicRoute && options.channel)
                this.baseTopicRoute = '/home/channel/' + options.channel.id + '/topics/';
        },
    });

    return TopicTagCollectionView;
});

